<template>
    <div class="datagrid-wrapper">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-2">
                    <div class="grid-buttons" v-if="true">
                        <a
                            class="btn btn-light"
                            :href="`/centre/${centre.id}/access/remote/create`"
                        >Grant remote access</a>
                    </div>
                    </div>
                    <div class="col-md-3">
                        <div class="type-selector">
                            <div class="form-group">
                                <select class="form-control" :value="status" @change="setStatus">
                                    <option value="">All</option>
                                    <option value="granted">Remote Access - Granted</option>
                                    <option value="rejected">Remote Access - Rejected</option>
                                    <option value="unreached">Remote Access - Unreached</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div data-type="grid" class="col-md-12">
                <table class="datagrid table access-request-list">
                    <thead>
                        <tr>
                            <th><h4>Name (Requested For) </h4></th>
                            <th><h4>Request type</h4></th>
                            <th><h4>Requested By</h4></th>
                            <th><h4>Requested On</h4></th>
                            <th><h4>Status</h4></th>
                            <th><h4>Actions</h4></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="remoteAccess in remoteAccesses.data" :key="remoteAccess.id">
                            <td>{{remoteAccess.requester.full_name}}</td>
                            <td>Remote Access</td>
                            <td>{{remoteAccess.staff.full_name}}</td>
                            <td>{{remoteAccess.requested_on}}</td>
                            <td>{{remoteAccess.status_label}}</td>
                            <td>
                                <a v-if="remoteAccess.status === 'pending'" :href="`remote/${remoteAccess.id}/edit`" class="btn btn-link link-button">Edit</a>
                                <a v-else :href="`remote/${remoteAccess.id}`" class="btn btn-link link-button">View</a>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3">
                                <ul class="pagination">
                                    <li v-for="page in remoteAccesses.meta.links" :key="page.label" :class="{'active': page.active}">
                                        <a v-if="page.url" :href="page.url" v-html="page.label"/>
                                        <span v-else v-html="page.label" />
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RemoteAccessesTableComponent",
        props: {
            centre: {
                type: Object,
                required: true,
            },
            remoteAccesses: {
                type: Object,
                required: true
            },
            status: {
                default: null
            }
        },
        methods: {
            setStatus(e) {
                let searchParams = new URLSearchParams(window.location.search)
                searchParams.delete('page')
                searchParams.set('status', e.target.value)

                window.location.search = searchParams.toString()
            }
        }
    }
</script>

<style scoped>
td:not(:last-child) {
    padding-right: 40px;
}
</style>
